import { localeSelector } from '@gandi/translate';
import { setPaymentCallParams } from '../money';
import { createOne, formatReturnUrl } from './resource';
export const submitMyCardCreation = (props, options) => (dispatch, getState) => {
  const state = getState();
  const {
    amount: _amount,
    name,
    provider,
    paymentProductId
  } = props;
  const {
    orderId,
    redirectTo,
    ...restOptions
  } = options;
  const amount = Number(_amount) || (provider === 'cm' ? undefined : 0);
  const return_url = redirectTo && formatReturnUrl(redirectTo, orderId) || undefined;
  const payload = {
    name,
    provider,
    lang: localeSelector(state),
    mean: provider === 'ay' ? 'dropin' : 'cc',
    payment_product_id: paymentProductId,
    order_id: orderId,
    amount: orderId ? undefined : amount,
    return_url
  };
  const onCreateGandiRegularPayement = response => {
    const {
      url,
      params,
      method
    } = response.data;
    const paymentForm = {
      url,
      params,
      method
    };
    dispatch(setPaymentCallParams(paymentForm));
    return paymentForm;
  };
  const onCreateAdyenPayement = response => {
    return {
      orderId: response.data.order_id,
      params: response.data.params
    };
  };
  return dispatch(createOne(payload, restOptions)).then(provider === 'ay' ? onCreateAdyenPayement : onCreateGandiRegularPayement);
};